import { useMemo, useState } from 'react';
import { CardBranch } from '@cencosud-cencommerce/paris-uikit';

import type { PickupItem } from '@/Application/Components/PickUpSelect/PickUpSelect';
import type {
  PickupOptionsProps,
  PickUpState
} from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/interfaces';

export const PickupOptionList = (props: PickupOptionsProps) => {
  const { id, pickupOptions, handleSelectClientSelection } = props;
  const selectedPickupOption = pickupOptions?.find((opt) => opt?.selected);
  const selectedValue = selectedPickupOption?.radioButton?.value;
  const hasSelected = selectedPickupOption && selectedValue;
  const firstPickup = pickupOptions?.[0]?.radioButton?.value;

  const [pickup, setPickup] = useState<PickUpState>(
    hasSelected ? selectedValue : firstPickup
  );

  const cardList: PickupItem[] | undefined = useMemo(
    () =>
      pickupOptions?.map((card) => ({
        ...card,
        selected: card?.selected || false,
        radioButton: card?.radioButton
          ? {
              ...card?.radioButton,
              onChange: () => {
                setPickup(card?.radioButton?.value);
                handleSelectClientSelection(id, {
                  shippingType: card.shippingType,
                  shippingMethod: card.shippingMethod,
                  shippingSubType: card.shippingSubType
                });
              }
            }
          : undefined
      })),
    [pickupOptions, id, handleSelectClientSelection]
  );

  const selectedCard = pickup ? pickup : undefined;

  return (
    <>
      {cardList?.map((card, index) => (
        <article
          key={index}
          className="co-w-full co-border-t co-border-t-neutral-300"
        >
          <CardBranch
            {...card}
            cta={undefined}
            oldPrice={card.crossedOutPrice}
            brandSize="md"
            radioButton={
              card?.radioButton && {
                ...card?.radioButton,
                name: `${id}-${props?.title}`,
                checked: card?.radioButton?.value === selectedCard,
                onChange: () => {
                  card?.radioButton?.onChange && card?.radioButton?.onChange();
                }
              }
            }
          />
        </article>
      ))}
    </>
  );
};

PickupOptionList.displayName = 'PickupOptionList';

export default PickupOptionList;
